import arrowRight from '@/assets/icons/icon-arrow-right.png';
import { decodeHtmlEntities } from '@/utils/decodeHtmlEntities';
import './TableOfContents.scss';

export interface TocItem {
  title: string;
  anchor: string;
}

interface TableOfContentsProps {
  title?: string;
  items: TocItem[];
}

export function TableOfContents({ title = 'Sommaire', items }: TableOfContentsProps) {
  if (items.length === 0) return null;

  return (
    <nav className="table-of-contents" aria-label={title}>
      <h2 className="table-of-contents__title">{title}</h2>
      <ul className="table-of-contents__list">
        {items.map((item) => (
          <li key={item.anchor} className="table-of-contents__item">
            <a
              href={`#${item.anchor}`}
              className="table-of-contents__link"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(item.anchor)?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <img
                className="table-of-contents__arrow"
                src={arrowRight}
                alt=""
                aria-hidden="true"
                width="16"
                height="16"
              />
              {decodeHtmlEntities(item.title)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
